import debugLog from 'utils/debugLog'

export type DataLayerEvents =
  | 'chatbotOpened'
  | 'chatbotInteracted'
  | 'chatbotFeedbackUsecasePositive'
  | 'chatbotFeedbackUsecaseNegative'
  | 'consentWidgetImpressed'
  | 'consentWidgetClicked'
  | 'consentWidgetOpened'

const dataLayerPushEvent = (event: DataLayerEvents, payload: object = {}) => {
  const data = { event, ...payload }
  if (window?.dataLayer) {
    const { dataLayer } = window

    dataLayer.push(data)
  }

  debugLog('Pushing data to dataLayer', data)
}

export default dataLayerPushEvent
